export const LogoImage = ({ className = "h-10 w-auto" }) => (
  <img
    src="/logo.png"
    alt="Pane Relief — Property Maintenance & Glass"
    className={className}
    draggable="false"
  />
);
